document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector("store-header");
    const menu = document.querySelector(".main-menu__disclosure");

    if (!header || !menu) return;

    let lastScrollTop = 0;

    window.addEventListener("scroll", function () {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (scrollTop > lastScrollTop && !menu.open) {
        header.classList.add("is-scrolled");
      } else {
        header.classList.remove("is-scrolled");
      }

      lastScrollTop = Math.max(scrollTop, 0);
    });

    // Empêche top:20px si menu ouvert
    menu.addEventListener("toggle", function () {
      if (menu.open) {
        header.classList.remove("is-scrolled");
      }
    });
  });